module.exports = __webpack_public_path__ + "img/download_vpn.33c2d244.svg";